import "../main/header.scss";
import { FaShoppingCart } from "react-icons/fa";
import logo2 from "../../assets/images/oil/logo2.png";
import { NavLink, Link } from "react-router-dom";
import useAuthentication from "hooks/useAuthentication";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { useContext, useState } from "react";
import CartModal from "common/order/CartModal";
import Search from "./Search";
import Container from "components/LogIn/Container";
import CartItemsContext from "context/CardItemsProvider";
import oilLogo from "assets/images/Logos/New Project.png";

function changeUserInformation(newInfo) {}
const Header = ({}) => {
  const User = useAuthentication();
  const auth = useContext(WithAuthentication);
  const {
    shoppingData,
    updateCartItem,
    cartItem,
    isLoading,
    setIsLoading,
    setProductUpdater,
  } = useContext(CartItemsContext);
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      {/* {auth.userInfo.userType == 1 && <CartModal></CartModal>} */}
      <CartModal />

      <nav
        onClick={() => setExpanded(expanded ? false : true)}
        className="navbar navbar-style navbar-expand-lg navbar-light  shadow"
      >
        <div className="container-fluid">
          {/* <NavLink
            className="navbar-brand"
            onClick={() => setExpanded(false)}
            to="/"
          ></NavLink> */}
          <NavLink
            className="nav-link"
            onClick={() => setExpanded(false)}
            to="/"
          >
            {/* <img src={logo2} style={{ width: "50px", height: "40px" }} /> */}
            <img
              src={oilLogo}
              className="rounded-pill"
              style={{ width: "80px" }}
            />
          </NavLink>

          {/* <Search></Search> */}
          <button
            className="navbar-toggler"
            type="button"
            // data-bs-toggle="collapse"
            // data-bs-target="#navbarNav"
            // aria-controls="navbarNav"
            aria-expanded={expanded ? true : false}
            // aria-expanded="false"
            // aria-label="Toggle navigation"
            onClick={() => setExpanded(expanded ? false : true)}
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div
            className={`collapse navbar-collapse justify-content-end ${
              expanded ? "show" : ""
            }`}
            id="navbarNav"
          >
            {/* <ul className="navbar-nav navbar_links ml-auto ">
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  onClick={() => setExpanded(false)}
                  to="/"
                >
                  خانه
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  onClick={() => setExpanded(false)}
                  to="/store"
                >
                  فروشگاه
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  onClick={() => setExpanded(false)}
                  to="/blog"
                >
                  وبلاگ
                </NavLink>
              </li>
            </ul> */}

            {!auth.isLogged ? (
              <div
                data-bs-toggle="modal"
                data-bs-target="#ModalNumber"
                className=" size1 text-decoration-none text-dark mx-5 text-center mt-2"
                style={{ cursor: "pointer", marginRight: "auto" }}
              >
                ورود
              </div>
            ) : (
              <>
                <div
                  className="user-link"
                  style={{
                    // marginRight: "auto",
                    whiteSpace: "nowrap",
                  }}
                >
                  <NavLink
                    to={`${
                      auth.userInfo.userType == 1
                        ? "/customer-panel/orders"
                        : "/admin-panel/orders"
                    }`}
                    className="nav-link "
                  >
                    {auth.userInfo.fullName == " "
                      ? "کاربر عزیز"
                      : auth.userInfo.fullName}
                  </NavLink>
                </div>
                <NavLink to={`/`} className="nav-link ">
                  <div
                    className="user-link exit-button"
                    onClick={() => {
                      setProductUpdater((prev) => !prev);
                      auth.logout();
                      updateCartItem();
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <a className="nav-link ">خروج</a>
                  </div>
                </NavLink>
              </>
            )}
            {/* {auth.userInfo.userType == 1 && ()} */}
            <div className="text-center">
              <button
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#CartModal"
                className="btn  mt-2 display-btn ms-3 position-relative "
                style={{ boxShadow: "none" }}
                onClick={() => {
                  updateCartItem();
                }}
              >
                <p className="position-relative d-inline">
                  <span
                    className="bg-danger text-light rounded-pill position-absolute px-1"
                    style={{ fontSize: 13, right: 16, top: -5 }}
                  >
                    {shoppingData.length}
                  </span>

                  <FaShoppingCart className="fa-solid fa-cart-shopping fs-4" />
                </p>
              </button>
            </div>
          </div>
        </div>
        <Container changeUserInformation={changeUserInformation} />
      </nav>
    </>
  );
};

export default Header;
